const HomeLocalization = {
    en: {
        title: "A new space adventure is coming...",
        release: "Coming soon",
        footer: "A game by",
        studio: "Synarion Games Studio",
        publishedBy: "published by",
        publisher: "Synarion Entertainments"
    },
    fr: {
        title: "Une nouvelle aventure spatiale arrive...",
        release: "Bientôt disponible",
        footer: "Un jeu de",
        studio: "Synarion Games Studio",
        publishedBy: "publié par",
        publisher: "Synarion Entertainments"
    },
    de: {
        title: "Ein neues Weltraumabenteuer kommt...",
        release: "Erscheint bald",
        footer: "Ein Spiel von",
        studio: "Synarion Games Studio",
        publishedBy: "veröffentlicht von",
        publisher: "Synarion Entertainments"
    },
    es: {
        title: "Una nueva aventura espacial está llegando...",
        release: "Lanzamiento próximamente",
        footer: "Un juego de",
        studio: "Synarion Games Studio",
        publishedBy: "publicado por",
        publisher: "Synarion Entertainments"
    },
    zh: {
        title: "全新的太空冒险即将到来...",
        release: "即将发布",
        footer: "由...开发",
        studio: "Synarion Games Studio",
        publishedBy: "发行",
        publisher: "Synarion Entertainments"
    },
    ru: {
        title: "Новое космическое приключение приближается...",
        release: "Скоро выход",
        footer: "Игра от",
        studio: "Synarion Games Studio",
        publishedBy: "издано",
        publisher: "Synarion Entertainments"
    },
    jp: {
        title: "新しい宇宙冒険がやってくる...",
        release: "まもなく発売",
        footer: "ゲーム制作：",
        studio: "Synarion Games Studio",
        publishedBy: "出版元：",
        publisher: "Synarion Entertainments"
    },
    kr: {
        title: "새로운 우주 모험이 다가오고 있습니다...",
        release: "곧 출시",
        footer: "게임 개발:",
        studio: "Synarion Games Studio",
        publishedBy: "배급:",
        publisher: "Synarion Entertainments"
    },
    it: {
        title: "Una nuova avventura spaziale sta arrivando...",
        release: "Uscita prossimamente",
        footer: "Un gioco di",
        studio: "Synarion Games Studio",
        publishedBy: "pubblicato da",
        publisher: "Synarion Entertainments"
    },
    pl: {
        title: "Nadchodzi nowa kosmiczna przygoda...",
        release: "Premiera wkrótce",
        footer: "Gra stworzona przez",
        studio: "Synarion Games Studio",
        publishedBy: "wydana przez",
        publisher: "Synarion Entertainments"
    },
    pt: {
        title: "Uma nova aventura espacial está chegando...",
        release: "Lançamento em breve",
        footer: "Um jogo de",
        studio: "Synarion Games Studio",
        publishedBy: "publicado por",
        publisher: "Synarion Entertainments"
    },
    tr: {
        title: "Yeni bir uzay macerası geliyor...",
        release: "Yakında çıkacak",
        footer: "Bir oyun",
        studio: "Synarion Games Studio",
        publishedBy: "yayıncı",
        publisher: "Synarion Entertainments"
    }
};

export default HomeLocalization;
